module.exports = __webpack_public_path__ + "static/media/RWFKO1024465_sm3.86ef65f8.png";